import { Usuario } from '../@types';
import Service from './Service';

// * stores the value of user to partial update
interface ExpireAt{
  id: string;
  validUntil: string;
}

export type { ExpireAt };

class UsuarioService extends Service {
  static getUsuarios() {
    return this.Http.get<Usuario.Usuario[]>('/users').then(this.getData);
  }

  static getUsuario(id: string) {
    return this.Http.get<Usuario.Usuario>(`/usuarios/${id}`).then(this.getData);
  }

  static setPassword(password:string) {
    return this.Http.put<{message:string}>('/auth/resetpassword', { password: password }).then(this.getData);
  }

  // A senha temporária é gerada aleatoriamente pelo backend e devolvida uma
  // única vez — não é mais o literal "Senha1234". Se não for exibida aqui,
  // ninguém consegue recuperá-la.
  static setResetPassword(userId:string) {
    return this.Http.put<{message:string; temporaryPassword:string}>(`/auth/resetpasswordbyid/${userId}`, ).then(this.getData);
  }

  static setExpiryDate(data:ExpireAt) {
    return this.Http.put<{message:string}>(`/auth/setexpirydate`, data).then(this.getData);
  }

  static inserirNovoUsuario(usuario: Usuario.Usuario) {
    return this.Http.post<Usuario.Usuario>('/auth/register', usuario).then(this.getData);
  }

  static atualizarUsuario(usuario: Usuario.Usuario) {
    return this.Http.put<Usuario.Usuario>(`/users`, usuario).then(this.getData);
  }

  static setUserStatus(id: string, active: boolean, emailVerified: boolean) {
    return this.Http.put<{ message: string }>(`/users/${id}/status`, { active, emailVerified }).then(this.getData);
  }
}

export default UsuarioService;
